import { useParams, Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { categoryComics, categories, comics } from '@/mocks/comics';

const coverImages: Record<string, string> = {
  'secret-class': 'https://readdy.ai/api/search-image?query=Secret%20Class%20Korean%20manga%20cover%20art%20illustration%20with%20soft%20romantic%20atmosphere%20warm%20lighting%20elegant%20composition&width=440&height=587&seq=comic-cover-01&orientation=portrait',
  'demon-king': 'https://readdy.ai/api/search-image?query=Demon%20King%20Returns%20Korean%20manga%20cover%20dramatic%20fantasy%20scene%20dark%20atmosphere%20powerful%20character%20illustration&width=440&height=587&seq=comic-cover-02&orientation=portrait',
  'love-signal': 'https://readdy.ai/api/search-image?query=Love%20Signal%20Korean%20romance%20manga%20cover%20sweet%20couple%20illustration%20pastel%20colors%20dreamy%20atmosphere&width=440&height=587&seq=comic-cover-03&orientation=portrait',
  'dark-detective': 'https://readdy.ai/api/search-image?query=Dark%20Detective%20Korean%20manga%20mystery%20noir%20cover%20atmospheric%20dark%20city%20street%20detective%20silhouette%20illustration&width=440&height=587&seq=comic-cover-04&orientation=portrait',
  'action-hero': 'https://readdy.ai/api/search-image?query=Fighting%20King%20Korean%20action%20manga%20cover%20dynamic%20martial%20arts%20scene%20powerful%20character%20intense%20battle%20illustration&width=440&height=587&seq=comic-cover-05&orientation=portrait',
  'star-romance': 'https://readdy.ai/api/search-image?query=Star%20Romance%20Korean%20manga%20cover%20beautiful%20couple%20under%20starry%20night%20sky%20romantic%20dreamy%20atmosphere%20soft%20colors&width=440&height=587&seq=comic-cover-06&orientation=portrait',
  'fantasy-world': 'https://readdy.ai/api/search-image?query=Isekai%20Reincarnation%20Korean%20fantasy%20manga%20cover%20magical%20world%20portal%20adventure%20colorful%20vibrant%20illustration&width=440&height=587&seq=comic-cover-07&orientation=portrait',
  'mystery-house': 'https://readdy.ai/api/search-image?query=Mystery%20House%20Korean%20horror%20suspense%20manga%20cover%20eerie%20mansion%20dark%20atmosphere%20chilling%20thriller%20illustration&width=440&height=587&seq=comic-cover-08&orientation=portrait',
  'school-fight': 'https://readdy.ai/api/search-image?query=School%20Fight%20Korean%20action%20manga%20cover%20students%20battle%20scene%20dynamic%20schoolyard%20setting%20energetic%20illustration&width=440&height=587&seq=comic-cover-09&orientation=portrait',
  'office-romance': 'https://readdy.ai/api/search-image?query=Office%20Romance%20Korean%20manga%20cover%20elegant%20workplace%20setting%20professional%20couple%20romantic%20tension%20sophisticated%20illustration&width=440&height=587&seq=comic-cover-10&orientation=portrait',
  'magic-academy': 'https://readdy.ai/api/search-image?query=Magic%20Academy%20Korean%20fantasy%20manga%20cover%20grand%20magical%20school%20students%20casting%20spells%20enchanting%20atmosphere%20illustration&width=440&height=587&seq=comic-cover-11&orientation=portrait',
  'crime-city': 'https://readdy.ai/api/search-image?query=Crime%20City%20Korean%20noir%20suspense%20manga%20cover%20dark%20urban%20landscape%20gritty%20crime%20scene%20intense%20thriller%20illustration&width=440&height=587&seq=comic-cover-12&orientation=portrait',
};

const categoryImages: Record<string, string> = {
  love: 'https://readdy.ai/api/search-image?query=Romantic%20Korean%20manga%20category%20banner%20soft%20warm%20pink%20and%20cream%20tones%20elegant%20illustrated%20couple%20scene%20artistic%20composition%20beautiful%20comic%20style&width=1600&height=600&seq=cat-hero-love&orientation=landscape',
  fantasy: 'https://readdy.ai/api/search-image?query=Fantasy%20Korean%20manga%20category%20banner%20magical%20world%20scene%20enchanting%20atmosphere%20vibrant%20colors%20mystical%20landscape%20artistic%20illustration%20professional&width=1600&height=600&seq=cat-hero-fantasy&orientation=landscape',
  action: 'https://readdy.ai/api/search-image?query=Action%20Korean%20manga%20category%20banner%20dynamic%20battle%20scene%20intense%20energy%20warm%20tones%20dramatic%20composition%20artistic%20illustration&width=1600&height=600&seq=cat-hero-action&orientation=landscape',
  suspense: 'https://readdy.ai/api/search-image?query=Mystery%20Korean%20manga%20category%20banner%20dark%20atmospheric%20noir%20scene%20city%20night%20intriguing%20composition%20artistic%20illustration&width=1600&height=600&seq=cat-hero-suspense&orientation=landscape',
  default: 'https://readdy.ai/api/search-image?query=Artistic%20Korean%20manga%20category%20banner%20elegant%20illustrated%20scene%20with%20soft%20warm%20lighting%20beautiful%20comic%20book%20style%20art%20composition%20with%20rich%20colors%20and%20storytelling%20atmosphere&width=1600&height=600&seq=category-hero&orientation=landscape',
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const catName = categories.find((c) => c.slug === slug)?.name || slug || '';
  const list = categoryComics[slug || ''] || comics;
  const [activeTab, setActiveTab] = useState(slug || 'love');

  useEffect(() => {
    setActiveTab(slug || 'love');
  }, [slug]);

  return (
    <>
      <Navbar />
      <Breadcrumb />
      <main>
        <div className="bg-background-50 w-full px-4 md:px-6 pt-6 pb-4">
          <div className="relative rounded-2xl overflow-hidden h-[320px] md:h-[400px]">
            <img
              src={categoryImages[slug || ''] || categoryImages.default}
              alt={`${catName}韩漫分类`}
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-8">
              <h1 className="font-heading text-3xl md:text-4xl font-bold text-white mb-2">
                {catName}漫画分类
              </h1>
              <p className="text-white/70 text-sm md:text-base">
                韩漫在线观看 · 漫画免费下拉式阅读 · {catName}韩国漫画全集
              </p>
            </div>
          </div>
        </div>

        <div className="bg-background-50 w-full px-4 md:px-6 pb-2">
          <div className="flex items-center gap-2 overflow-x-auto pb-2" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
                  activeTab === cat.slug
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-100 text-foreground-700 hover:bg-background-200/80'
                }`}
              >
                <i className={`${cat.icon} text-sm w-4 h-4 flex items-center justify-center`} />
                {cat.name}
                <span className={`text-xs ${activeTab === cat.slug ? 'text-white/70' : 'text-foreground-400'}`}>
                  {cat.count}
                </span>
              </Link>
            ))}
          </div>
        </div>

        <section className="bg-foreground-950 py-14 md:py-18">
          <div className="w-full px-4 md:px-6">
            <div className="flex items-center gap-3 mb-10">
              <span className="inline-block px-4 py-1.5 rounded-full border border-foreground-700 text-foreground-300 text-xs font-medium whitespace-nowrap">
                {catName || '全部作品'}
              </span>
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-white leading-tight">
                {catName}精选
              </h2>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-5">
              {list.map((comic) => (
                <Link
                  key={comic.id}
                  to={`/comic/${comic.slug}`}
                  className="group cursor-pointer"
                >
                  <div className="aspect-[3/4] rounded-xl overflow-hidden bg-background-200 mb-3">
                    <img
                      src={coverImages[comic.id] || ''}
                      alt={`${comic.title} - 韩国漫画`}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                      loading="lazy"
                    />
                  </div>
                  <div className="px-1">
                    <h3 className="font-heading text-sm md:text-base font-bold text-white truncate mb-1">
                      {comic.title}
                    </h3>
                    <p className="text-xs text-foreground-500 flex items-center gap-2">
                      <span className={`px-1.5 py-0.5 rounded text-[10px] font-medium whitespace-nowrap ${
                        comic.status === '连载中' ? 'bg-accent-100 text-accent-700' : 'bg-secondary-100 text-secondary-700'
                      }`}>
                        {comic.status}
                      </span>
                      <span className="truncate">{comic.author}</span>
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />

      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "首页", "item": "http://zhidavip.com/" },
            { "@type": "ListItem", "position": 2, "name": catName || '漫画分类', "item": `http://zhidavip.com/category/${slug || ''}` }
          ]
        })
      }} />

      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          "name": `${catName}韩漫分类 - 韩国漫画网`,
          "description": `韩国漫画网${catName}分类页面，韩漫在线观看，漫画免费下拉式阅读，好看的韩国漫画全集完整阅读。`,
          "url": `http://zhidavip.com/category/${slug || ''}`,
          "isPartOf": {
            "@type": "WebSite",
            "name": "韩国漫画网",
            "url": "http://zhidavip.com/"
          },
          "mainEntity": {
            "@type": "ItemList",
            "itemListElement": list.map((comic, i) => ({
              "@type": "ListItem",
              "position": i + 1,
              "item": {
                "@type": "Article",
                "name": comic.title,
                "url": `http://zhidavip.com/comic/${comic.slug}`,
                "author": { "@type": "Person", "name": comic.author },
                "genre": comic.categoryName
              }
            }))
          }
        })
      }} />
    </>
  );
}